/*
  Drives the bundle buy box (snippets/bundle-buy-box.liquid):
  - Syncs how many "slot" boxes are visible to the selected pack size
  - Clicking any slot box opens a shared slide-out drawer. Each scent there shows
    an "Add +" button; clicking it turns that row into a quantity stepper
    (- count +), so a customer can add multiple of the same scent (e.g. 3x Holy
    Grail) or a mix of different scents, up to the pack size total
  - Picks flatten back into the slot boxes (read-only display) and into hidden
    line-item-property inputs (Scent 1, Scent 2, ...) in drawer-list order
  - Add to Cart stays natively disabled until the total picked equals the pack
    size — no auto-fill, no fallback
  - Toggles the Subscribe & Save selling-plan select on/off with purchase type
  - Submits via the AJAX cart API and hands off to the site's existing cart-open
    flow (same pattern as assets/custom-product-card-atc.js), so OCU's Slide
    Cart Drawer picks it up exactly like any other add-to-cart.
*/
(function () {
  function initBundleBuyBox(root) {
    const form = root.querySelector('[data-bundle-form]');
    if (!form || form.dataset.bundleInitialized) return;
    form.dataset.bundleInitialized = 'true';

    const variantIdInput = form.querySelector('[data-bundle-variant-id]');
    const packInputs = Array.from(form.querySelectorAll('[data-pack-size-input]'));
    const slotRows = Array.from(form.querySelectorAll('[data-slot-row]'));
    const slotTriggers = Array.from(form.querySelectorAll('[data-scent-slot-trigger]'));
    const slotClears = Array.from(form.querySelectorAll('[data-scent-slot-clear]'));
    const valueInputs = Array.from(form.querySelectorAll('[data-scent-value]'));
    const submitBtn = form.querySelector('[data-bundle-submit]');
    const drawerSubmitBtn = root.querySelector('[data-drawer-submit]');
    const message = form.querySelector('[data-bundle-validation-message]');
    const purchaseOnetime = form.querySelector('[data-purchase-onetime]');
    const purchaseSubscribe = form.querySelector('[data-purchase-subscribe]');
    const sellingPlanWrap = form.querySelector('[data-selling-plan-wrap]');
    const sellingPlanSelect = form.querySelector('[data-selling-plan-select]');

    const overlay = root.querySelector('[data-scent-overlay]');
    const drawer = root.querySelector('[data-scent-drawer]');
    const drawerClose = root.querySelector('[data-scent-drawer-close]');
    const drawerProgress = root.querySelector('[data-drawer-progress]');
    const drawerItems = Array.from(root.querySelectorAll('[data-scent-option]'));

    // scent value -> quantity chosen. Absent/0 means not chosen.
    const quantities = {};
    let lastTrigger = null;

    function totalSelected() {
      return Object.keys(quantities).reduce((sum, key) => sum + quantities[key], 0);
    }

    function packSize() {
      const checkedPack = packInputs.find((el) => el.checked);
      const fallback = parseInt(form.dataset.defaultScentCount, 10) || drawerItems.length;
      const count = checkedPack ? parseInt(checkedPack.dataset.scentCount, 10) : fallback;
      return Number.isFinite(count) && count > 0 ? count : fallback;
    }

    function trimToCapacity(capacity) {
      let total = totalSelected();
      if (total <= capacity) return;
      const keys = Object.keys(quantities);
      for (let i = keys.length - 1; i >= 0 && total > capacity; i--) {
        const key = keys[i];
        while (quantities[key] > 0 && total > capacity) {
          quantities[key] -= 1;
          total -= 1;
        }
        if (quantities[key] <= 0) delete quantities[key];
      }
    }

    function computeFlatList() {
      const flat = [];
      drawerItems.forEach((item) => {
        const value = item.dataset.scentValue;
        const qty = quantities[value] || 0;
        for (let i = 0; i < qty; i++) flat.push(value);
      });
      return flat;
    }

    function syncFlatValues() {
      const flat = computeFlatList();
      valueInputs.forEach((input, idx) => {
        input.value = flat[idx] || '';
      });
    }

    function syncValueInputsEnabled() {
      const capacity = packSize();
      valueInputs.forEach((input) => {
        const slot = parseInt(input.dataset.slot, 10);
        input.disabled = slot > capacity;
      });
    }

    function syncVariantId() {
      const checkedPack = packInputs.find((el) => el.checked);
      if (checkedPack && variantIdInput) {
        variantIdInput.value = checkedPack.value;
      }
    }

    function syncSlotVisibility() {
      const capacity = packSize();
      slotRows.forEach((row) => {
        const slot = parseInt(row.dataset.slot, 10);
        row.hidden = slot > capacity;
      });
    }

    function clearButtonForSlot(slot) {
      return slotClears.find((el) => el.dataset.slot === String(slot));
    }

    function updateSlots() {
      const flat = computeFlatList();
      slotTriggers.forEach((slotBtn) => {
        const slot = parseInt(slotBtn.dataset.slot, 10);
        const value = flat[slot - 1];
        const textEl = slotBtn.querySelector('[data-slot-text]');
        const descEl = slotBtn.querySelector('[data-slot-desc]');
        const swatchEl = slotBtn.querySelector('[data-slot-swatch]');
        const clearBtn = clearButtonForSlot(slot);

        if (value) {
          slotBtn.dataset.filled = 'true';
          if (clearBtn) clearBtn.hidden = false;
          const matchingOption = drawerItems.find((el) => el.dataset.scentValue === value);
          const img = matchingOption ? matchingOption.querySelector('img') : null;
          const description = matchingOption ? matchingOption.dataset.scentDescription : '';

          if (textEl) textEl.textContent = value;
          if (descEl) {
            if (description) {
              descEl.hidden = false;
              descEl.textContent = description;
            } else {
              descEl.hidden = true;
              descEl.textContent = '';
            }
          }
          if (swatchEl) {
            if (img) {
              swatchEl.hidden = false;
              swatchEl.innerHTML = '<img src="' + img.src + '" alt="" width="56" height="56">';
            } else {
              swatchEl.hidden = true;
              swatchEl.innerHTML = '';
            }
          }
        } else {
          slotBtn.dataset.filled = 'false';
          if (textEl) textEl.textContent = slotBtn.dataset.placeholder || textEl.textContent;
          if (descEl) {
            descEl.hidden = true;
            descEl.textContent = '';
          }
          if (clearBtn) clearBtn.hidden = true;
          if (swatchEl) {
            swatchEl.hidden = true;
            swatchEl.innerHTML = '';
          }
        }
      });
    }

    function updateDrawerItem(item) {
      const value = item.dataset.scentValue;
      const qty = quantities[value] || 0;
      const total = totalSelected();
      const capacity = packSize();
      const addBtn = item.querySelector('[data-scent-add]');
      const stepper = item.querySelector('[data-scent-stepper]');
      const countEl = item.querySelector('[data-stepper-count]');
      const incBtn = item.querySelector('[data-stepper-increment]');
      const decBtn = item.querySelector('[data-stepper-decrement]');

      if (qty > 0) {
        if (addBtn) addBtn.hidden = true;
        if (stepper) stepper.hidden = false;
        if (countEl) countEl.textContent = String(qty);
        if (decBtn) decBtn.disabled = false;
        if (incBtn) incBtn.disabled = total >= capacity;
      } else {
        if (addBtn) {
          addBtn.hidden = false;
          addBtn.disabled = total >= capacity;
        }
        if (stepper) stepper.hidden = true;
      }
    }

    function updateDrawerItems() {
      drawerItems.forEach(updateDrawerItem);
    }

    function updateProgress() {
      if (!drawerProgress) return;
      drawerProgress.textContent = 'Selected ' + totalSelected() + ' of ' + packSize();
    }

    function validate() {
      const capacity = packSize();
      const total = totalSelected();
      const remaining = capacity - total;
      if (submitBtn) submitBtn.disabled = remaining !== 0;
      if (drawerSubmitBtn) drawerSubmitBtn.disabled = remaining !== 0;
      if (message) {
        message.textContent = remaining > 0
          ? 'Choose ' + remaining + ' more scent' + (remaining > 1 ? 's' : '') + ' to continue.'
          : '';
      }
      return remaining === 0;
    }

    function refreshAll() {
      syncFlatValues();
      updateSlots();
      updateDrawerItems();
      updateProgress();
      validate();
    }

    function trapFocus() {
      if (window.theme && theme.a11y && typeof theme.a11y.trapFocus === 'function') {
        theme.a11y.trapFocus({
          container: drawer,
          elementToFocus: drawerClose,
          namespace: 'bundleScentDrawer',
        });
      }
    }
    function releaseFocus() {
      if (window.theme && theme.a11y && typeof theme.a11y.removeTrapFocus === 'function') {
        theme.a11y.removeTrapFocus({ container: drawer, namespace: 'bundleScentDrawer' });
      }
    }

    function openDrawer(originEl) {
      if (!overlay || !drawer) return;
      lastTrigger = originEl || null;
      updateDrawerItems();
      updateProgress();
      overlay.hidden = false;
      drawer.hidden = false;
      trapFocus();
      if (drawerClose) drawerClose.focus();
      document.addEventListener('keydown', onKeydown);
    }

    function closeDrawer() {
      if (!overlay || !drawer) return;
      overlay.hidden = true;
      drawer.hidden = true;
      releaseFocus();
      document.removeEventListener('keydown', onKeydown);
      if (lastTrigger) lastTrigger.focus();
      lastTrigger = null;
    }

    function onKeydown(event) {
      if (event.key === 'Escape') closeDrawer();
    }

    slotTriggers.forEach((slotBtn) => {
      const textEl = slotBtn.querySelector('[data-slot-text]');
      if (textEl) slotBtn.dataset.placeholder = textEl.textContent;
      slotBtn.addEventListener('click', () => openDrawer(slotBtn));
    });

    slotClears.forEach((clearBtn) => {
      clearBtn.addEventListener('click', (event) => {
        event.stopPropagation();
        const slot = parseInt(clearBtn.dataset.slot, 10);
        const value = computeFlatList()[slot - 1];
        if (!value || !quantities[value]) return;
        quantities[value] -= 1;
        if (quantities[value] <= 0) delete quantities[value];
        refreshAll();
      });
    });

    if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    drawerItems.forEach((item) => {
      const value = item.dataset.scentValue;
      const addBtn = item.querySelector('[data-scent-add]');
      const incBtn = item.querySelector('[data-stepper-increment]');
      const decBtn = item.querySelector('[data-stepper-decrement]');

      if (addBtn) {
        addBtn.addEventListener('click', () => {
          if (totalSelected() >= packSize()) return;
          quantities[value] = 1;
          refreshAll();
        });
      }
      if (incBtn) {
        incBtn.addEventListener('click', () => {
          if (totalSelected() >= packSize()) return;
          quantities[value] = (quantities[value] || 0) + 1;
          refreshAll();
        });
      }
      if (decBtn) {
        decBtn.addEventListener('click', () => {
          if (!quantities[value]) return;
          quantities[value] -= 1;
          if (quantities[value] <= 0) delete quantities[value];
          refreshAll();
        });
      }
    });

    packInputs.forEach((input) => {
      input.addEventListener('change', () => {
        syncVariantId();
        syncValueInputsEnabled();
        syncSlotVisibility();
        trimToCapacity(packSize());
        refreshAll();
      });
    });

    if (purchaseOnetime && purchaseSubscribe && sellingPlanWrap && sellingPlanSelect) {
      function syncPurchaseType() {
        const subscribing = purchaseSubscribe.checked;
        sellingPlanWrap.hidden = !subscribing;
        sellingPlanSelect.disabled = !subscribing;
      }
      purchaseOnetime.addEventListener('change', syncPurchaseType);
      purchaseSubscribe.addEventListener('change', syncPurchaseType);
      syncPurchaseType();
    }

    const submitButtons = [submitBtn, drawerSubmitBtn].filter(Boolean);

    function setSubmitting(isSubmitting) {
      submitButtons.forEach((btn) => {
        btn.disabled = isSubmitting;
        btn.classList.toggle('is-loading', isSubmitting);
      });
    }

    // Listening on the button's click (not form submit) and calling
    // preventDefault() here stops a submit event from ever being dispatched
    // at all, so nothing else on the page (e.g. an app's own cart hooks) has
    // anything to intercept. The button itself stays natively disabled until
    // validate() confirms the total picked equals the pack size, so this
    // only ever runs with real, complete data. Shared by the main form button
    // and the drawer's own "Add to Cart" button, so picking the last scent
    // and buying without leaving the drawer works the same way.
    function handleAddToCart(event) {
      event.preventDefault();
      if (!validate()) return;

      closeDrawer();
      setSubmitting(true);

      const formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
        credentials: 'same-origin',
      })
        .then((res) => {
          if (!res.ok) {
            return res.json().then((body) => {
              throw new Error(body.description || 'Could not add this bundle to your cart.');
            });
          }
          return res.json();
        })
        .then(() => {
          try {
            document.dispatchEvent(new CustomEvent('cart:build'));
          } catch (e) {
            /* no-op */
          }
          const drawerTrigger = document.querySelector('.js-drawer-open-cart');
          if (drawerTrigger) {
            drawerTrigger.dispatchEvent(new Event('click', { bubbles: true }));
          }
        })
        .catch((err) => {
          if (message) message.textContent = err.message;
        })
        .finally(() => {
          setSubmitting(false);
          validate();
        });
    }

    submitButtons.forEach((btn) => btn.addEventListener('click', handleAddToCart));

    syncValueInputsEnabled();
    syncSlotVisibility();
    refreshAll();
  }

  document.querySelectorAll('[data-bundle-buy-box]').forEach(initBundleBuyBox);

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-bundle-buy-box]').forEach(initBundleBuyBox);
  });
})();
